import { Component, OnInit } from '@angular/core';
import ProactiveUnderPerformingKeywordValidationState from 'app/specialist/actioncomponents/ProactiveUnderPerformingKeywordValidationState';
import ITaskFilesPublicApi = app.components.interfaces.ITaskFilesPublicApi;
import { TaskNoteService } from '../../../../services/task-note.service';
import { UpaChecklistService } from '../../../../services/upa-checklist.service';
import Utils from '../../../../shared/utils';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-components-specialist-actioncomponents-proactiveunderperformingkeyword',
  templateUrl: './ProactiveUnderPerformingKeyword.component.html'
})
export class ProactiveUnderPerformingKeywordComponent implements OnInit, IPersistableActionWorkspace, IActivatable {
  actionViewModel: KnockoutObservable<IActionWorkspace>;
  currentAction: KnockoutObservable<Boo.Objects.Action>;
  customer: Boo.Objects.Customer;
  taskId: number;
  noteMaxCharacters = 500;
  validationState: KnockoutObservable<ProactiveUnderPerformingKeywordValidationState> = ko.observable(new ProactiveUnderPerformingKeywordValidationState());
  taskFilesApi: ITaskFilesPublicApi;
  upaChecklists: Boo.Objects.Checklist.UpaChecklist[];
  validationApi: app.interfaces.IValidationPublicApi;
  customerCampaignRestrictions: Boo.Objects.CustomerCampaign.Enums.RestrictionTypes[] = [
    Boo.Objects.CustomerCampaign.Enums.RestrictionTypes.ReadOnly,
    Boo.Objects.CustomerCampaign.Enums.RestrictionTypes.HideTrackingTab,
    Boo.Objects.CustomerCampaign.Enums.RestrictionTypes.HideArchivedTab,
    Boo.Objects.CustomerCampaign.Enums.RestrictionTypes.HideStrategyUpdateRequestButton
  ];

  private childComponentValidations: { validation: app.interfaces.IValidate, uid: string }[] = [];

  constructor(
    private taskNoteService: TaskNoteService,
    private upaChecklistService: UpaChecklistService) { }

  ngOnInit(): void {
    this.validationApi = {
      add: this.addValidation.bind(this),
      remove: this.removeValidation.bind(this)
    }
  }

  getFilesApi: (api: ITaskFilesPublicApi) => void = (api) => {
    this.taskFilesApi = api;
  }

  activate(params: any): JQueryPromise<void> {
    params.controlViewModel(this);
    this.actionViewModel = ko.observable(null);
    this.currentAction = params.currentAction;
    this.customer = this.currentAction().Customer;
    this.taskId = this.currentAction().Task.TaskId;

    return Utils.wrapDfd(this.upaChecklistService.getOrCreate(this.taskId))
      .then(upaChecklists => {
        this.upaChecklists = upaChecklists;
        const validationState = this.validationState();
        validationState.hasGottenChecklistResponse = true;
        this.validationState(validationState);
      });
  }

  isStepReadyToReject(): boolean {
    return false;
  }

  reject(): Observable<void> {
    return of(void 0);
  }

  isStepReadyToSave(): boolean {
    const currentState = this.validationState();
    return currentState.hasGottenKeywordsResponse && currentState.hasGottenChecklistResponse
  }

  save(): Observable<void> {
    return this.upaChecklistService.save(this.upaChecklists);
  }

  isStepReadyToComplete(): boolean {
    const completeValidationState = this.validationState();

    completeValidationState.hasFiles = this.taskFilesApi.getFiles().length > 0;

    if (!completeValidationState.hasGottenKeywordsResponse) {
      toastr.error('Error loading customer keywords.');
      return false;
    }

    if (!completeValidationState.hasGottenChecklistResponse) {
      toastr.error('Error loading checklist.');
      return false;
    }

    const invalidChildren = this.childComponentValidations.filter(x => !x.validation.isValid());
    invalidChildren.forEach(child =>
      child.validation.validate().done((result: app.interfaces.IValidatedResult) => {
        result.errorMessages.forEach(msg => toastr.error(msg));
      })
    );

    if (invalidChildren.length > 0) {
      return false;
    }

    this.validationState(completeValidationState);

    return true;
  }

  complete(): Observable<void> {
    return this.upaChecklistService.save(this.upaChecklists);
  }

  isStepReadyToDelete(): boolean {
    return false;
  }

  delete(): Observable<void> {
    return of(void 0);
  }

  addValidation(validation: app.interfaces.IValidate, uid: string): void {
    this.childComponentValidations.push({ validation, uid });
  }

  removeValidation(uid: string): void {
    this.childComponentValidations = this.childComponentValidations.filter(x => x.uid !== uid);
  }
}
